import React from "react";
import { Users } from "lucide-react";

export default function EmptyRealtors() {
  return (
    <div
      className="rounded-lg border border-dashed border-slate-200 bg-white p-10 text-center"
      data-testid="realtors-empty-state"
    >
      <Users className="h-7 w-7 mx-auto text-slate-300 mb-3" />
      <h3 className="text-sm font-medium text-slate-900">No realtors yet</h3>
      <p className="text-sm text-slate-500 mt-1">
        Approve a brokerage and run “Scrape agents” — or add a realtor manually.
      </p>
    </div>
  );
}
